module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Monster-Dancer-Web-1280.9fe7c726.jpg";